import React from "react";
import { Box, Typography } from "@mui/material";
import { INK } from "../Ink";

// Monochrome 14px glyphs keyed by badge kind. Stroke follows currentColor.
const GLYPHS = {
  level: <circle cx="7" cy="7" r="5" fill="currentColor" />,
  streak: (
    <g fill="currentColor">
      <rect x="2" y="7" width="2" height="6" /><rect x="6" y="4" width="2" height="9" /><rect x="10" y="1" width="2" height="12" />
    </g>
  ),
  mission: <path d="M2 7.5l3.5 3.5L12 4" stroke="currentColor" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round" />,
  artist: <path d="M7 1.5l1.7 3.6 3.9.5-2.9 2.7.8 3.9L7 10.3l-3.5 1.9.8-3.9L1.4 5.6l3.9-.5z" stroke="currentColor" strokeWidth="1.3" fill="none" strokeLinejoin="round" />,
  default: <rect x="2.5" y="2.5" width="9" height="9" stroke="currentColor" strokeWidth="1.4" fill="none" />,
};

export function glyphKind(badge) {
  if (!badge) return "default";
  const kind = String(badge.kind || badge.type || badge.category || "").toLowerCase();
  if (kind) {
    if (kind.includes("level")) return "level";
    if (kind.includes("streak")) return "streak";
    if (kind.includes("mission")) return "mission";
    if (kind.includes("artist") || kind.includes("custom")) return "artist";
  }
  if (badge.artistId) return "artist";
  const key = String(badge.key || badge.name || "").toLowerCase();
  if (key.includes("streak")) return "streak";
  if (key.includes("mission")) return "mission";
  if (key.includes("level")) return "level";
  return "default";
}

export default function BadgeGlyph({ badge, muted = false }) {
  const label = badge?.title || badge?.name || badge?.key || "Badge";
  const color = muted ? INK.dim : INK.text;
  return (
    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75, color, mr: 2, mb: 0.75 }} title={badge?.description || label}>
      <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" style={{ display: "block", flexShrink: 0 }}>
        {GLYPHS[glyphKind(badge)]}
      </svg>
      <Typography component="span" sx={{ fontSize: 12, color, whiteSpace: "nowrap" }}>{label}</Typography>
    </Box>
  );
}
